module.exports = __webpack_public_path__ + "static/media/4280.94e8a717.jpg";